module.exports = __webpack_public_path__ + "pdf/innovation.aeb3144.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/innovation.pdf
// module id = oxqA
// module chunks = 0